import { useEffect, useLayoutEffect } from 'react'
import { useParams } from 'react-router-dom'

import { useBookingContext } from '@providers/booking/booking_context'
import { i18WithDefault as t } from '@shared/locale'
import { SearchOffersByDay } from './search_offers_by_day'
import { SearchOffersGeneral } from './search_offers_general'
import { SearchOffersGrooming } from './search_offers_grooming'
import { SearchOffersPackages } from './search_offers_packages'

export const SearchOffers = () => {
  const { serviceTypeName = '' } = useParams()
  const bookingCtx = useBookingContext()

  useEffect(() => {
    document.title = t('title.selectOffer')
  }, [])

  useLayoutEffect(() => {
    bookingCtx.dispatch({ type: 'CLEAR_OFFERS_SEARCH_RESULTS' })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  switch (serviceTypeName) {
    case 'daycare':
      return <SearchOffersByDay />
    case 'grooming':
      return <SearchOffersGrooming />
    case 'packages':
      return <SearchOffersPackages />
    default:
      return <SearchOffersGeneral />
  }
}
